export default __webpack_public_path__ + "static/media/3foldEmbryo.df60fcbd.svg";